import OrderOptimizerDetailsUpdateRequest, {
  OrderOptimizerDetailsUpdateRequestBody,
} from "./order-optimizer-details-update.request";

const createBody = (
  request: OrderOptimizerDetailsUpdateRequest,
): OrderOptimizerDetailsUpdateRequestBody => {
  return {
    status: request.status,
  };
};

const orderOptimizerDetailsUpdateRequestFactory = {
  createBody,
};

export default orderOptimizerDetailsUpdateRequestFactory;
